import React,{ useState, useEffect } from 'react';
import {
    Button
} from 'antd';

import HardwareSetupMenu from './support/HardwareSetupMenu';
import ModemSetup from './support/ModemSetup';
import ModemConnectivity from './support/ModemConnectivity';
import InternetTroubleshooting from './support/InternetTroubleshooting';
import InternetTermsOfService from './support/InternetTermsOfService';
import RouterSetup from './support/RouterSetup';
import RouterConnectivity from './support/RouterConnectivity';
import STBSetup from './support/STBSetup';
import RemoteGuide from './support/RemoteGuide';
import TVAccountSetup from './support/TVAccountSetup';
import TVTroubleshooting from './support/TVTroubleshooting';
import TVTermsOfService from './support/TVTermsOfService';
import ATASetup from './support/ATASetup';

function HardwareSetup() {
    const [ activeComponent, setActiveComponent ] = useState( <ModemSetup /> );
    const [ defaultOpenKeys, setDefaultOpenKeys ] = useState( [] );
    const [ defaultSelectedKeys, setDefaultSelectedKeys ] = useState( [] ); 

    useEffect(() => {
        const url_string = window.location.href;
        let url = new URL(url_string);
        const hardwareType = url.searchParams.get("hardware"); 
    
        console.log( "hardwareType: ", hardwareType );

        switch( hardwareType ) {
            case 'modems' :
            setActiveComponent( <ModemSetup /> );
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'modem-setup'] );
            break;
            case 'routers' :
            setActiveComponent( <RouterSetup /> );
            //setDefaultOpenKeys( ['sub2'] );
            setDefaultSelectedKeys( ['sub2', 'router-setup'] );
            break;
            case 'stb' :
            setActiveComponent( <STBSetup /> );
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'stb-setup'] );
            break;
            case 'ata' :
            setActiveComponent( <ATASetup /> );
            //setDefaultOpenKeys( ['sub4'] );
            setDefaultSelectedKeys( ['sub4', 'voice-adapter-connection'] );
            break;
            case 'troubleshooting' :
            setActiveComponent( <InternetTroubleshooting /> );
            //setDefaultOpenKeys( ['sub4'] );
            setDefaultSelectedKeys( ['sub1', 'internet-troubleshooting'] );
            break;
            default:
            setActiveComponent( <ModemSetup /> );
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'modem-setup'] );
            break;
        } 
    
    }, [setDefaultOpenKeys]);
    
    const handleMenuItemClick = ( e ) => {
        let componentToRender = <></>;

        //console.log('key: ', e.key);

        switch( e.key ) {
            case 'modem-setup':
            componentToRender = <ModemSetup />;
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'modem-setup'] );
            break;
            case 'modem-connectivity':
            componentToRender = <ModemConnectivity />;
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'modem-connectivity'] );
            break;
            case 'internet-troubleshooting':
            componentToRender = <InternetTroubleshooting />;
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'internet-troubleshooting'] );
            break;
            case 'terms-of-service':
            componentToRender = <InternetTermsOfService />;
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'terms-of-service'] );
            break;
            case 'terms-of-service':
            componentToRender = <InternetTermsOfService />;
            //setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'terms-of-service'] );
            break;
            case 'sub1':
            componentToRender = <RouterSetup />;
            //setDefaultOpenKeys( ['sub2'] );
            setDefaultSelectedKeys( ['sub2', 'router-setup'] );
            break;
            case 'router-setup':
            componentToRender = <RouterSetup />;
            //setDefaultOpenKeys( ['sub2'] );
            setDefaultSelectedKeys( ['sub2', 'router-setup'] );
            break;
            case 'wifi-coverage':
            componentToRender = <RouterConnectivity />;
            //setDefaultOpenKeys( ['sub2'] );
            setDefaultSelectedKeys( ['sub2', 'wifi-coverage'] );
            break;
            case 'stb-setup':
            componentToRender = <STBSetup />;
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'stb-setup'] );
            break;
            case 'remote-guide':
            componentToRender = <RemoteGuide />;
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'remote-guide'] );
            break;
            case 'tv-account-setup':
            componentToRender = <TVAccountSetup />;
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'tv-account-setup'] );
            break;
            case 'tv-troubleshooting':
            componentToRender = <TVTroubleshooting />;
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'tv-troubleshooting'] );
            break;
            case 'tv-terms-of-service':
            componentToRender = <TVTermsOfService />;
            //setDefaultOpenKeys( ['sub3'] );
            setDefaultSelectedKeys( ['sub3', 'tv-terms-of-service'] );
            break;
            case 'voice-adapter-connection':
            componentToRender = <ATASetup />;
           // setDefaultOpenKeys( ['sub4'] );
            setDefaultSelectedKeys( ['sub4', 'voice-adapter-connection'] );
            break;
        }

        setActiveComponent( componentToRender );
    }

    return (
        <div id="react-hardware-setup-component">
            <div className="sidebar-menu-desktop">
                <HardwareSetupMenu 
                    handleMenuItemClick={ handleMenuItemClick }
                    openKeys={ defaultOpenKeys }
                    selectedKeys={ defaultSelectedKeys }
                />
            </div>
            <div className='content-container'>
                { activeComponent }
            </div>
        </div>
    )
}

export default HardwareSetup